<template>
  <v-col class="pa-0">
    <v-row
      no-gutters
      class="my-3"
      align="center"
    >
      <div class="text-h6 mr-3">Операции</div>
      <v-divider />
      <v-btn
        :loading="$balanceOperation.loadings.list"
        @click="loadList"
        depressed
        color="primary"
        class="ml-3 rounded-lg text-none body-2"
        >Обновить
      </v-btn>
    </v-row>
    <BalanceOperations
      ref="balanceOperations"
      in-user
    ></BalanceOperations>
  </v-col>
</template>

<script>
  import Search from '@/components/template/Search'
  import BalanceOperations from '@/admin/views/balanceOperations/BalanceOperations.vue'

  export default {
    name: 'Users',
    components: {
      Search,
      BalanceOperations
    },
    methods: {
      loadList() {
        this.$refs.balanceOperations.loadList()
      }
    }
  }
</script>

<style scoped></style>
